import { useEffect } from "react";
import { clearFilterTourDetails, setFilterTourDetails } from "./tourSlice";
import { getAllTours } from "./services/tour.services";
import _debounce from "lodash/debounce";
import { useLocation, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

export const NOOFDAYS = [
  { label: "1 to 3 days", value: "(NoOfDays BETWEEN 1 AND 3)" },
  { label: "4 to 7 days", value: "(NoOfDays BETWEEN 4 AND 7)" },
  { label: "8 to 13 days", value: "(NoOfDays BETWEEN 8 AND 13)" },
  { label: "14 to 19 days", value: "(NoOfDays BETWEEN 14 AND 19)" },
  { label: "More than 19 days", value: "(NoOfDays > 19)" },
];
export const RATE = [
  { label: "0 to 10000", value: "Rate BETWEEN 0 AND 10000" },
  { label: "10000 to 20000", value: "Rate BETWEEN 10000 AND 20000" },
  { label: "20000 to 30000", value: "Rate BETWEEN 20000 AND 30000" },
  { label: "30000 to 50000", value: "Rate BETWEEN 30000 AND 50000" },
  { label: "50000 to 200000", value: "Rate BETWEEN 50000 AND 200000" },
];
export const SHORT_BY_FILTER = [
  {
    label: "Price Low to High",
    value: "ORDER BY RATE ASC",
  },
  {
    label: "Price High to Low",
    value: "ORDER BY RATE DESC",
  },
  {
    label: "Duration Short to Long",
    value: "ORDER BY NoOfDays ASC",
  },
  {
    label: "Duration Long to Short",
    value: "ORDER BY NoOfDays DESC",
  },
];

const TourFilter = ({ formik }: { formik: any }) => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const SectorURL = params?.SectorURL;
  const location = useLocation();
  const SpecialityType = location.state?.SpecialityType;
  const FilterTourDetails = useAppSelector(
    (state) => state.tour.FilterTourDetails
  );

  useEffect(() => {
    dispatch(
      setFilterTourDetails({
        ...FilterTourDetails,
        Rate: formik.values?.Rate,
        NoOfDays: formik.values?.NoOfDays,
        OrderBy: formik.values?.OrderBy,
        TourType: formik.values?.TourType,
      })
    );
  }, [formik.values, location.pathname]);

  const delayedApiCall = _debounce((filter) => {
    dispatch(getAllTours(filter));
  }, 200);

  useEffect(() => {
    const filter = {
      ...FilterTourDetails,
      Rate: FilterTourDetails?.Rate || "",
      SectorURL: SectorURL || "",
      NoOfDays: FilterTourDetails.NoOfDays?.join(" OR "),
      TourType: FilterTourDetails?.TourType?.join(","),
      SpecialityType: SpecialityType
        ? `${SpecialityType}`
        : `${FilterTourDetails.SpecialityType}`,
      OrderBy:
        FilterTourDetails.OrderBy &&
        typeof FilterTourDetails.OrderBy === "object"
          ? FilterTourDetails.OrderBy?.value
          : FilterTourDetails.OrderBy
          ? FilterTourDetails.OrderBy
          : "",
    };
    delayedApiCall(filter);

    return () => delayedApiCall.cancel();
  }, [FilterTourDetails]);

  const handleCheckboxChange = (value: any, arrayField: string) => {
    formik.setFieldValue(
      arrayField,
      formik.values[arrayField]?.includes(value)
        ? formik.values[arrayField]?.filter((item: any) => item !== value)
        : [...formik.values[arrayField], value]
    );
  };

  const handleRadioChange = async (
    value: string,
    field: string,
    formik: any
  ) => {
    formik.setFieldValue(field, value);
  };

  useEffect(() => {
    if (formik && formik.values) {
      dispatch(
        setFilterTourDetails({ ...FilterTourDetails, ...formik.values })
      );
    }
  }, [formik.values]);

  return (
    <>
      <div className="sidebar position-sticky" style={{ top: 100 }}>
        <div className="tour-sidebar-title">
          <h4>Criteria</h4>
          <a
            href=""
            onClick={(e: any) => {
              e.preventDefault();
              dispatch(clearFilterTourDetails());
              formik.resetForm();
            }}
          >
            Clear all <img src="/images/x.png" alt="" />
          </a>
        </div>
        <div className="sidebar-block">
          <h5>Your budget</h5>
          {RATE?.map((rate: any) => (
            <div className="field">
              <input
                type="radio"
                className="filter-checkbox me-2"
                name="Rate"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={rate?.value}
                checked={formik.values.Rate === rate?.value}
              />
              <label
                className="ps-1"
                htmlFor={rate?.value}
                onClick={() => handleRadioChange(rate?.value, "Rate", formik)}
              >
                {rate?.label}
              </label>
            </div>
          ))}
        </div>
        <div className="sidebar-block">
          <h5>Trip Length </h5>
          {NOOFDAYS?.map((day: any) => (
            <div className="field">
              <input
                type="checkbox"
                className="filter-checkbox me-2"
                name="NoOfDays"
                value={day?.value}
                checked={formik.values?.NoOfDays?.includes(day?.value)}
                onChange={() => handleCheckboxChange(day?.value, "NoOfDays")}
              />
              <label
                className="ps-1"
                htmlFor={day?.value}
                onClick={() => handleCheckboxChange(day?.value, "NoOfDays")}
              >
                {day?.label}
              </label>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default TourFilter;
